import { useQuery } from '@tanstack/react-query';
import { getResumo } from '../../queries/ScheduleHub';
import { useUserStore } from '../../../Auth/stores/authStore';

export const useGetHubResume = (scheduleId?: string) => {
  const user = useUserStore((state) => state.user);
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ['getHubResume', scheduleId || user?.id],
    queryFn: () => getResumo(scheduleId),
    enabled: !!user?.id,
    retryOnMount: false,
    retry: false,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { data, isPending, isError, refetch };
};
